import { emailSaved } from 'actions/emailSaved';
import { progressCleared } from 'actions/progressCleared';

import { resetArkose } from 'hooks/useArkose';

import { selectFormDataEmail } from 'selectors/form';

import { IS_EMBEDDED } from 'utils/queryParamHelpers';
import cookies from 'utils/storage/cookies';

const resetEnrollment = () => {
  return (dispatch, getState) => {
    const state = getState();
    const email = selectFormDataEmail(state);

    dispatch(progressCleared());
    resetArkose();

    if (!IS_EMBEDDED && email) {
      cookies.set('landing_email', email);
      dispatch(emailSaved({ email }));
    }
    /** Not returning default response value because this gets called for misc reasons.
     * Remember to handle error messages as needed
     */
    return;
  };
};

export default resetEnrollment;
